
import { defineComponent, ref, computed } from "vue";
export default defineComponent({
  name: "Input",
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "text",
    },
    modelValue: {
      type: String,
      required: true,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
  },
  setup(prp) {
    const inputFocused = ref(false);
    const inputColor = computed(() => {
      if (prp.error) {
        return "var(--red-100)";
      }

      if (!prp.modelValue) {
        return "var(--gray-100)";
      }

      return "var(--green-100)";
    });

    return { inputFocused, inputColor };
  },
});
